import { useEffect, useMemo } from "react";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const PowerMapPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: powerMapData = [] } = useGetProtectedApiDataQuery({
    url: "power_map",
    lang: languageType,
  });

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  // last updated on
  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(powerMapData);
  }, [powerMapData]);

  useEffect(() => {
    const BASE_URL = process.env.REACT_APP_JS_URL || "";

    let script1, script2, script3, script4;

    if (languageType === "") {
      // English scripts
      script1 = document.createElement("script");
      script1.src = `${BASE_URL}/js/mapDataInner.js`;
      script1.async = true;

      script2 = document.createElement("script");
      script2.src = `${BASE_URL}/js/countrymapInner.js`;
      script2.async = true;

      document.head.appendChild(script1);
      document.head.appendChild(script2);
    } else if (languageType === "hi") {
      // Hindi scripts
      script3 = document.createElement("script");
      script3.src = `${BASE_URL}/js/mapDataInnerHindi.js`;
      script3.async = true;

      script4 = document.createElement("script");
      script4.src = `${BASE_URL}/js/countrymapInnerHindi.js`;
      script4.async = true;

      document.head.appendChild(script3);
      document.head.appendChild(script4);
    }

    return () => {
      // Clean up the scripts when the component unmounts
      if (script1 && script2) {
        document.head.removeChild(script1);
        document.head.removeChild(script2);
      }
      if (script3 && script4) {
        document.head.removeChild(script3);
        document.head.removeChild(script4);
      }
    };
  }, [languageType]);
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={getText("Power Generation", "विद्युत उत्पादन")}
        titleLink="/power-generation"
        levelTwo={true}
        titleTwo={innerBannerTitle}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                {/* <div className="title-sec">
                  <h4>Power Map</h4>
                </div> */}
                <div className="power-generation-box inner-power-generation-box wow zoomIn">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                      <div className="innermapsection">
                        <div className="legend-section2">
                          <ul className="legenddiv2">
                            <div className="legend-title2">
                              {getText("Legends", "शीर्षक")}
                            </div>
                            {/* <li>
                              <span>-----</span>International Boundary
                            </li>
                            <li>
                              <span>-----</span>State Boundary
                            </li> */}
                            <li>
                              <span>
                                <img src="/images/legend1.png" alt="" />
                              </span>{" "}
                              {getText("National Capital", "राष्ट्रीय राजधानी")}
                            </li>
                            <li>
                              <span>
                                <img src="/images/legend2.png" alt="" />
                              </span>{" "}
                              {getText("State Capital", "राज्य की राजधानी")}
                            </li>
                            <li>
                              <span>
                                <img src="/images/legend3.png" alt="" />
                              </span>
                              {getText(
                                "Commissioned Hydro Projects",
                                "चालू जल विद्युत परियोजनाएँ",
                              )}
                            </li>
                            <li>
                              <span>
                                <img src="/images/legend4.png" alt="" />
                              </span>
                              {getText(
                                "Commissioned Thermal Project",
                                "चालू ताप विद्युत परियोजना",
                              )}
                            </li>
                            <li>
                              <span>
                                <img src="/images/legend5.png" alt="" />
                              </span>
                              {getText(
                                "Commissioned Solar Project",
                                "चालू सौर परियोजना",
                              )}
                            </li>
                            <li>
                              <span>
                                <img src="/images/legend6.png" alt="" />
                              </span>
                              {getText(
                                "Future Hydro Project",
                                "भविष्य की जल विद्युत परियोजना",
                              )}
                            </li>
                            <li>
                              <span>
                                <img src="/images/legend7.png" alt="" />
                              </span>
                              {getText(
                                "Future Hydro Project in Joint Venture",
                                "संयुक्त उद्यम में भविष्य की जल विद्युत परियोजना",
                              )}
                            </li>
                          </ul>
                        </div>
                        <div className="india-mapdiv"></div>
                        <div className="map-sec">
                          <div id="map"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerMapPage;
